import { render, staticRenderFns } from "./status-column.vue?vue&type=template&id=489f4084"
import script from "./status-column.vue?vue&type=script&lang=js"
export * from "./status-column.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('489f4084')) {
      api.createRecord('489f4084', component.options)
    } else {
      api.reload('489f4084', component.options)
    }
    module.hot.accept("./status-column.vue?vue&type=template&id=489f4084", function () {
      api.rerender('489f4084', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/import/status-column.vue"
export default component.exports